// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"461":"1894b6c1","538":"37bbac85","672":"56b52703","808":"56a4c44e","868":"9001d57b","937":"615ab28b","948":"38ccafa8","983":"d2424f5a"}[chunkId] + ".chunk.js";
};